import { createLinks } from "common-frontend-components";
export const wwwRoutes = {
    home: '/',
    posts: '/posts',
    post: '/posts/:postId',
    gallery: '/gallery',
    galleryCategory: '/gallery/:categoryId',
    products: '/products',
    product: '/products/:productId',
    about: '/about',
    book: '/book',
    privacy: '/privacy',
    terms: '/terms-and-conditions',
    cookies: '/cookies-policy',
    contact: '/contact',
    search: '/search',
};
export const wwwLinks = createLinks(wwwRoutes);
//# sourceMappingURL=wwwRoutes.js.map